var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:'help-button ' + _vm.cssClass,attrs:{"title":"Help"},on:{"click":function($event){return _vm.$router.push('/help')}}},[_vm._v("\n  ?\n")])}
var staticRenderFns = []

export { render, staticRenderFns }